import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { getFileById } from "../../apis/media-api";
import { holloProfileImageStyles } from "./hollo-profile-image-styles";

@customElement("hollo-profile-image")
export class HolloProfileImage extends LitElement {
  @property({ type: String }) fileId = "";
  @property({ type: String }) alt = "";
  @property({ type: Number }) size = 32;
  @property({ type: String }) class = "";
  @state() private src?: string;
  @state() private loading = false;

  protected willUpdate(changed: Map<string, unknown>) {
    if (changed.has("fileId")) {
      this.startLoad();
    }
  }

  private async startLoad() {
    const id = this.fileId;
    if (!id) {
      this.src = undefined;
      this.loading = false;
      return;
    }
    // set loading synchronously during the same update frame
    if (!this.loading) this.loading = true;
    const dataUrl = await getFileById(id);
    // Only apply if the id hasn't changed mid-flight
    if (this.fileId !== id) return;
    this.src = dataUrl || undefined;
    this.loading = false;
  }

  render() {
    const px = `${this.size}px`;
    if (this.loading) {
      return html`<div
        class="hollo-placeholder"
        style="width:${px};height:${px};"
      ></div>`;
    }
    if (!this.src) return null;
    return html`<img
      class="hollo-avatar hollo-click-circle ${this.class}"
      src=${this.src}
      alt=${this.alt}
      style="width:${px};height:${px};"
    />`;
  }

  static styles = holloProfileImageStyles;
}

declare global {
  interface HTMLElementTagNameMap {
    "hollo-profile-image": HolloProfileImage;
  }
}
